/**
 * CenteredColumnLayout
 *
 * Structural layout component that horizontally centers its children
 * using Bootstrap's grid system. Side columns act as responsive spacers.
 *
 * Props:
 * - children: content to be rendered in the center column
 * - centerClass: Bootstrap column classes for the center content
 * - rowClass: optional extra classes for the row container
 */
import React, { useState } from 'react';

const RowColLayout = ({children, centerClass = "col-12",  rowClass = "",}) => {

  return (
    <div className={`row d-flex justify-content-center align-items-center p-1 m-1 ${rowClass}`}>
    
      {/* inner column */}
      <div className={`${centerClass} d-flex flex-column justify-content-center align-items-center p-0 m-0`}>
        {children}
      </div>

    </div>

  );
};

export default RowColLayout;
